// Instant-hero handoff for /browse/:type/:id (TV audit 2026-09-05, P1).
//
// The card (or hero slide) the user activates already knows the title,
// poster, backdrop and overview of the title it links to. Stash that here
// keyed by `${mediaType}-${id}` so BrowseMediaView can paint a preview hero on
// the same frame the route changes, instead of a spinner for the ~1.2 s the
// TMDB details round-trip takes on the Chromecast. Pure module state (no Vue,
// no storage): entries are small, short-lived (TTL) and capped.

const TTL_MS = 60_000;
const MAX_ENTRIES = 24;
const entries = new Map();

function keyFor(mediaType, id) {
  return `${mediaType || "movie"}-${id}`;
}

/** Remember the card data for a title the user is about to open. */
export function setBrowseHandoff(mediaType, id, data) {
  if (id == null || !data) return;
  const key = keyFor(mediaType, id);
  entries.delete(key);
  entries.set(key, {
    at: Date.now(),
    data: { ...data, mediaType: mediaType || "movie" },
  });
  while (entries.size > MAX_ENTRIES) {
    entries.delete(entries.keys().next().value);
  }
}

/** Read (without consuming) the handoff for a title, or null when none/stale. */
export function readBrowseHandoff(mediaType, id) {
  const entry = entries.get(keyFor(mediaType, id));
  if (!entry) return null;
  if (Date.now() - entry.at > TTL_MS) {
    entries.delete(keyFor(mediaType, id));
    return null;
  }
  return entry.data;
}

/** Build the handoff payload from a normalized TMDB item (services/tmdb.js). */
export function handoffFromItem(item) {
  if (!item) return null;
  return {
    title: item.title || item.name || "",
    poster: item.poster || null,
    backdrop: item.backdrop || null,
    overview: item.overview || "",
    year: item.year || null,
    vote_average: item.vote_average ?? null,
    vote_count: item.vote_count ?? null,
  };
}
